import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BriefcaseIcon, LayoutDashboardIcon, LogOutIcon, SettingsIcon, UsersIcon } from 'lucide-react';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
const nav = [{
  label: 'Overblik',
  to: '/admin',
  icon: LayoutDashboardIcon,
  end: true
}, {
  label: 'Sager',
  to: '/admin/sager',
  icon: BriefcaseIcon,
  end: false
}, {
  label: 'Kunder',
  to: '/admin/kunder',
  icon: UsersIcon,
  end: false
}, {
  label: 'Indstillinger',
  to: '/admin/indstillinger',
  icon: SettingsIcon,
  end: false
}];
export function AdminShell() {
  const {
    logout
  } = useAdminData();
  const navigate = useNavigate();
  return <div className="flex min-h-screen w-full bg-canvas" data-id="element-27" data-mp="246hmc2dejn9m">
      <aside className="hidden w-56 shrink-0 flex-col border-r border-line bg-white lg:flex" data-id="element-28" data-mp="ntu24jl6u16e">
        <div className="px-6 py-6" data-id="element-29" data-mp="ssdryv2wjx41">
          <img src={company.logoWide} alt="LYKKEVÆRK" className="h-9 w-auto" data-id="element-30" data-mp="stf30zjx4jlr" />
          <p className="mt-2 text-xs uppercase tracking-[0.18em] text-ink-muted" data-id="element-31" data-mp="30sowj48mu5bn">Admin</p>
        </div>
        <nav aria-label="Adminnavigation" className="flex flex-col gap-1 px-3" data-id="element-32" data-mp="2vv6y47s8r8hw">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors duration-200 ease-smooth ${isActive ? 'bg-ink text-white' : 'text-ink-soft hover:bg-canvas hover:text-ink'}`} data-id="element-33" data-mp="3asfrt850oocs">
              <item.icon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-34" data-mp="3thdz77pc6ipi" />
              {item.label}
            </NavLink>)}
        </nav>
        <button type="button" onClick={() => {
        logout();
        navigate('/admin/login');
      }} className="mx-3 mb-6 mt-auto inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:bg-canvas hover:text-ink" data-id="element-35" data-mp="6cofpa7t2kep">
          <LogOutIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-36" data-mp="eef7tfdufio3" />
          Log ud
        </button>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-37" data-mp="o3ytstwursn6">
        <header className="sticky top-0 z-40 border-b border-line bg-white/95 px-5 py-3 backdrop-blur lg:hidden" data-id="element-38" data-mp="o5i9ojelk1of">
          <div className="flex items-center justify-between" data-id="element-39" data-mp="s5ao3cqo921p">
            <div data-id="element-40" data-mp="x3lvlgthv0gr">
              <img src={company.logoWide} alt="LYKKEVÆRK" className="h-8 w-auto" data-id="element-41" data-mp="x32chws3y615" />
              <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-42" data-mp="124rrfnigb3ui">Admin</p>
            </div>
            <button type="button" onClick={() => {
            logout();
            navigate('/admin/login');
          }} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft" data-id="element-43" data-mp="172b2yfnrl2ir">
              <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="1q0mnyh2d8a27" />
              Log ud
            </button>
          </div>
        </header>

        <main className="min-w-0 flex-1 pb-24 lg:pb-0" data-id="element-45" data-mp="1h6rh94llibkg">
          <Outlet data-id="element-46" data-mp="1h7jboc3gi395" />
        </main>

        <nav aria-label="Adminnavigation" className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-line bg-white/95 backdrop-blur lg:hidden" data-id="element-47" data-mp="1h4dncz2nj5eh">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `flex flex-1 flex-col items-center gap-1 py-3 text-[11px] transition-colors duration-200 ease-smooth ${isActive ? 'text-accent' : 'text-ink-muted'}`} data-id="element-48" data-mp="24wlsxiu6hu34">
              <item.icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-49" data-mp="ofpyktip1xw6" />
              {item.label}
            </NavLink>)}
        </nav>
      </div>
    </div>;
}